/*
 * @Author: Latte
 * @Date: 2021-07-28 10:04:01
 * @LAstEditors: Latte
 * @LastEditTime: 2021-07-28 10:23:11
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\diagnosisManagement\diagnosticUserManagement.js
 */

import request from '@/utils/request'
import config from '@/utils/config'

/**
 * @description: 获取会诊角色用户
 * @param {*} params
 * @return {*}
 */
export function getAllUserList(params) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/user/list',
    method: 'get',
    params
  })
}

/**
 * @description: 获取单个会诊用户详情
 * @param {*} params
 * @return {*}
 */
 export function getUserDetail(params) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/user/detail',
    method: 'get',
    params
  })
}

/**
 * @description: 删除会诊用户角色
 * @param {*} params
 * @return {*}
 */
 export function deleteUser(params) {
  return request({
    url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/user/delete',
    method: 'delete',
    params
  })
}